export const preloadImage = (src: string) => {
  return new Promise((resolve) => {
    const image = new Image();
    image.addEventListener('load', resolve);
    image.src = src;
  });
};
